import React from "react";

import {useFoodForms} from "@client/features/foods";
import * as search from "@client/features/search";

import * as router from "@client/router";
import * as analytics from "@client/shared/analytics";

import {submitForm} from "@client/site/forms";
import {server} from "@reactivated";

export const CreateFood = router.CreateFood.withHooks(() => {
    return useFoodForms({initial: null});
})
    .withTab(
        {
            name: "macros",
            icon: "bullseye",
            title: "Macros",
            hasErrors: (props) => props.basicLayout.hasErrors,
        },
        (props) => <>{props.basicLayout.component}</>,
    )
    .withTab(
        {
            name: "advanced",
            icon: "list",
            title: "Advanced",
            hasErrors: (props) => props.advancedLayout.hasErrors,
        },
        (props) => <>{props.advancedLayout.component}</>,
    )
    .withActions((props) => [
        props.form.values.name.toLowerCase() === "sentry throw exception"
            ? {
                  icon: "0442-power" as const,
                  title: "Throw Exception",
                  onClick: () => {
                      throw new Error("Throwing an exception.");
                  },
              }
            : null,
        props.form.values.name.toLowerCase() === "sentry undefined function"
            ? {
                  icon: "0442-power" as const,
                  title: "Undefined Function",
                  onClick: () => {
                      const invalidAccess = {};
                      // @ts-expect-error Intentional for Sentry testing
                      alert(invalidAccess.deeplyNested()); // eslint-disable-line
                  },
              }
            : null,
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const result = await submitForm(
                    server.journal.nutrition.create_food,
                    props.form.values,
                    props.form,
                );
                if (result.type === "success") {
                    void props.dispatch(search.loadSearch({reset: true}));
                    props.notify("Your food was created");
                    router.push("food_list.index", {});
                    void analytics.track("CREATED_FOOD");
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Create Food",
        // In case we arrive from corrections or missing UPC.
        back: "My Foods",
        scene: {kind: "SIMPLE"},
    }));
